var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.812,
    height: 17.812,
    viewBox: "0 0 17.812 17.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus-regular",
    d: "M33.812,56.915a1.025,1.025,0,0,1-1.028,1.028H25.933v6.851a1.028,1.028,0,1,1-2.055,0V57.943H17.028a1.028,1.028,0,0,1,0-2.055h6.851V49.037a1.028,1.028,0,0,1,2.055,0v6.851h6.851A1.028,1.028,0,0,1,33.812,56.915Z",
    transform: "translate(-16 -48.01)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRegular);
export default __webpack_public_path__ + "static/media/plus-regular.5dc52d3451873b73c978791ad2753b78.svg";
export { ForwardRef as ReactComponent };